<template>
  <Navbar/>
  <Section>
    <img class="bannerestatico" src="@/assets/banners/catalogo/puntosventa.png ">
  </Section>

  <section class="locations-section">

    <div class="section-header">
      <h2>Encuentra nuestros productos ✨</h2>
    </div>


    <div class="cards-grid">
      <LocationCard
        v-for="store in stores"
        :key="store.id"
        :video="store.video"
        :title="store.name"
        :subtitle="store.city"
        :badge="store.badge"
        :mapsUrl="store.mapsUrl"
      />
    </div>

  </section>
    <section style="padding-top: 0px;">
    <Footer />
  </section>
  
</template>

<script setup>
import LocationCard from '@/components/LocationCard.vue'
import Navbar from '@/components/Navbar.vue'
import Footer from '@/components/Footer.vue'

//videos
import harmonyVid from '@/assets/videos/roperito.mp4'
//import roperito from '@/assets/videos/video2.mp4'
//import aiconic from '@/assets/videos/video3.mp4'
//import ambar from '@/assets/videos/video4.mp4'


const stores = [
  {
    id: 1,
    name: 'HARMONY COLECTIVO',
    city: 'Córdoba, Veracruz',
    badge: 'Tienda Física',
    video: harmonyVid,
    mapsUrl:'https://maps.app.goo.gl/nrjkjyfaP6FBGLzF6'
  },
  {
    id: 2,
    name: 'MI ROPERTIO',
    city: 'Orizaba, Veracruz',
    badge: 'Beauty Station',
    video: harmonyVid,
    mapsUrl:'https://maps.app.goo.gl/QtqCieE7hPcR2hyL6',
  },
  {
    id: 3,
    name: 'AICONIC COLECTIVO',
    city: 'Orizaba, Veracruz',
    badge: 'Punto de Venta',
    video: harmonyVid,
    mapsUrl:'https://maps.app.goo.gl/yP6ehxKPd4GnP5Z16'
  },
]
</script>

<style scoped>
.locations-section {
  padding: 4rem 8%;
  background-color: #11146d;
}

.section-header {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0rem 2rem 8rem 2rem;

}

.section-header h2 {
  color:azure;
  margin: 3rem;
    text-align: center;
    font-size: clamp(3rem, 4vw, 5rem);
    letter-spacing: 1px;
    text-transform: uppercase;
    font-family: "Magistral_Bold";
    color: #BAECFF;
}

.cards-grid {
  display: grid;
  grid-template-columns:
    repeat(auto-fit, minmax(350px, 1fr));
  gap: 20px;
}
.overlay{
    position: none;
    inset: 0;
    background: red;
  }


.badge{
  
}

@media (max-width: 768px) {
  .locations-section {
    padding: 2rem 5%;
  }

  .cards-grid {
    grid-template-columns: 1fr;
  }
}
</style>

